export const PRE_SAVE_ANSWER = "PRE_SAVE_ANSWER";
export const SAVE_SOLUTION_SECTION = "SAVE_SOLUTION_SECTION";
export const UPDATE_CHECK = "UPDATE_CHECK";
export const UPDATE_OTHER_WHICH = "UPDATE_OTHER_WHICH";
export const DELETE_OTHER_WHICH = "DELETE_OTHER_WHICH";
export const SET_INITIAL_OPEN_QUESTION = "SET_INITIAL_OPEN_QUESTION";
export const SET_INITIAL_SECTION = "SET_INITIAL_SECTION";
export const UPDATE_ANSWERS = "UPDATE_ANSWERS";
export const DECLINE_SURVEY = "DECLINE_SURVEY";
